export const GET_ROLES_REQUEST = "GET_ROLES_REQUEST"
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS"
export const GET_ROLES_ERROR = "GET_ROLES_ERROR"
